import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { getRequest, postRequest } from "../../../utils/api";
import { logout } from "../../../utils/auth";
import { toast } from "react-toastify";

const AssignAffiliateModal: React.FC<any> = ({ show, onHide, userData = {} }) => {
    const [loading, setLoading] = useState(false);
    const [commissionLoading, setCommissionLoading] = useState(false);

    const [affiliateList, setAffiliateList] = useState<any[]>([]);
    const [userId, setUserId] = useState("");
    const [affiliateId, setAffiliateId] = useState("");

    const fetchCommissionList = async () => {
        try {
            setLoading(true);

            const response = await getRequest(
                "/user/affiliate-list"
            );

            if (response.status === "success") {
                setAffiliateList(response.data || []);
            } else if (response.status === "session_expired") {
                logout();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show && userData) {
            setUserId(userData._id);
            setAffiliateId(userData.user_affiliate_id ? userData.user_affiliate_id : '');
            fetchCommissionList();
        }
    }, [show, userData]);

    const handleCommissionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAffiliateId(e.target.value);
    };

    const handleSubmit = async () => {
        if (!affiliateId) {
            toast.error("Please select affiliate");
            return;
        }

        try {
            setCommissionLoading(true);

            const response = await postRequest(
                "/user/assign-affiliate-to-user",
                {
                    userId: userId,
                    affiliateId: affiliateId,
                }
            );

            if (response.status === "success") {
                toast.success(response.message); 
                onHide();
            } else if (response.status === "session_expired") {
                logout();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        } finally {
            setCommissionLoading(false);
        }
    };

    // Check if the user already has an affiliate assigned from the start
    const hasExistingAffiliate = Boolean(userData?.user_affiliate_id);

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Affiliate List</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <div className="row">
                        <div className="col-lg-12 mb-3">
                            <Form.Group>
                                <Form.Label>Affiliate</Form.Label>
                                <Form.Select
                                    value={affiliateId}
                                    onChange={handleCommissionChange}
                                    // Disable the dropdown if loading OR if already assigned
                                    disabled={loading || hasExistingAffiliate}
                                >
                                    <option value="">
                                        {loading ? "Loading..." : "Select Affiliate"}
                                    </option>

                                    {affiliateList.map((item) => (
                                        <option key={item._id} value={item._id}>
                                            {item.affiliate_companyName || "-"} ({item.affiliate_first_name} {item.affiliate_last_name})
                                        </option>
                                    ))}
                                </Form.Select>
                                
                                {/* Optional: Show a message explaining why it's disabled */}
                                {hasExistingAffiliate && (
                                    <Form.Text className="text-muted mt-2 d-block">
                                        An affiliate is already assigned to this user and cannot be changed.
                                    </Form.Text>
                                )}
                            </Form.Group>
                        </div>
                    </div>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onHide}>
                    Close
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    // Disable the submit button if already assigned or currently processing
                    disabled={commissionLoading || hasExistingAffiliate}
                >
                    {commissionLoading ? "Processing..." : "Submit"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssignAffiliateModal;